@use '../../styling/typography.scss' as *;

.TruncatedString {
  @extend %font-family-primary;

  &.notWrapped {
    white-space: nowrap;
  }

  &.wrapped {
    white-space: normal;
  }
}
